import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, ArrowLeft } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => {}); }, [slug]);
  if (!post) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-500" /></div>;
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <Link to="/blog" className="text-sm text-emerald-600 font-semibold flex items-center gap-1 mb-4"><ArrowLeft className="h-4 w-4" /> Blog'a dön</Link>
      <span className="text-xs font-bold text-emerald-700 bg-emerald-50 px-2.5 py-1 rounded-full">{post.category}</span>
      <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 mt-4">{post.title}</h1>
      <div className="text-sm text-slate-400 mt-2">{post.author} • {new Date(post.created_at).toLocaleDateString("tr-TR")}</div>
      {post.cover && <img src={post.cover} alt={post.title} className="w-full h-72 object-cover rounded-2xl mt-6" />}
      <div className="prose prose-slate max-w-none mt-6 text-slate-700 leading-relaxed whitespace-pre-line">{post.content}</div>
    </article>
  );
}
